module.exports = __webpack_public_path__ + "img/2024SEA.18c027ae.png";